import { SearchTarget } from '@/types'

export interface BibliographyAuthorityPublisherSearchRequest {
  searchTarget: SearchTarget
  numberOfLimit: number
  publisher: string
  publisherNo: string
}

export function BibliographyAuthorityPublisherSearchRequestToJSON(
  value: BibliographyAuthorityPublisherSearchRequest
): any {
  return {
    search_target: value.searchTarget ?? undefined,
    number_of_limit: value.numberOfLimit ?? undefined,
    publisher: value.publisher !== '' ? value.publisher : undefined,
    publisher_no: value.publisherNo !== '' ? value.publisherNo : undefined
  }
}
